// Pounce on/off — poore account ke liye. Off: koi call nahi, aayi leads hold pe.
// On: calls chalu, aur off ke dauraan aayi leads ho to poochta hai — call karein
// ya chhod dein. Jawab diye bina app band ho jaye to agli baar khulte hi phir poochta hai.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import styles from "./PounceToggle.module.css";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import { getPounceStatus, resolvePounceHeldLeads, setPounceEnabled } from "../../../Store/apiStore";
import { usePounceLeadEvents,usePouncePermissions } from "../pounceLeadShared";
import usePounceAccess, { POUNCE_LOCK_MESSAGE } from "../../../hooks/usePounceAccess";
import { useDashboardStore } from "../../../Store/agentZustandStore";

// Team access wala middleware `error` key me jawab deta hai, baaki routes `message` me.
const errorText = (err, fallback) => err?.response?.data?.message || err?.response?.data?.error || fallback;

const PounceToggle = ({ onChange }) => {
  // Team me sirf admin / "edit agents" wala badal sakta hai; baaki ko haal dikhta hai.
  const { canEditAgents } = usePouncePermissions();
  // Store me rakha hai taaki har screen pe toggle off se on na "jhapke" —
  // pichhla haal turant dikhta hai. null = abhi pata nahi.
  const enabled = useDashboardStore((s) => s.pounceEnabled);
  const setEnabled = useDashboardStore((s) => s.setPounceEnabledCache);
  const [held, setHeld] = useState(0); // >0 aur on = sawaal dikhao
  const [busy, setBusy] = useState(false);
  // On/off poore account pe lagta hai — sirf jise edit ka haq ho.
  const { canEdit } = usePounceAccess();

  const apply = (s) => {
    setEnabled(s.enabled);
    setHeld(s.enabled ? s.heldLeads || 0 : 0);
  };

  const sync = useCallback(() => getPounceStatus().then(apply).catch(() => {}), []);
  useEffect(() => {
    sync();
  }, [sync]);
  // Doosre device se badla ho to bhi yahan sahi dikhe.
  usePounceLeadEvents(sync);

  const toggle = async () => {
    if (busy || enabled === null || !canEdit) return;
    setBusy(true);
    try {
      apply(await setPounceEnabled(!enabled));
      onChange?.();
    } catch (err) {
      toast.error(errorText(err, "We couldn't update Outbound Caller. Please try again."));
    } finally {
      setBusy(false);
    }
  };

  const resolve = async (action) => {
    setBusy(true);
    try {
      await resolvePounceHeldLeads(action);
      setHeld(0);
      onChange?.();
    } catch (err) {
      toast.error(errorText(err, "We couldn't update those leads. Please try again."));
    } finally {
      setBusy(false);
    }
  };

  const on = enabled === true;

  return (
    <>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={on ? "Outbound Caller is on — turn off calling" : "Outbound Caller is off — turn on calling"}
        className={`${styles.wrap} ${on ? styles.on : ""}`}
        onClick={toggle}
        disabled={busy || enabled === null || !canEdit}
        title={canEdit ? undefined : POUNCE_LOCK_MESSAGE}
      >
        <span className={styles.dot} aria-hidden="true" />
        <span className={styles.track} aria-hidden="true">
          <span className={styles.knob} />
        </span>
      </button>

      <ConfirmModal
        show={on && held > 0 && canEdit}
        type="info"
        title="Call the leads you missed?"
        message={`You have ${held} lead${held === 1 ? "" : "s"} that came in while Outbound Caller was off. Do you want Outbound Caller to call ${held === 1 ? "it" : "them"} now?`}
        showCancel
        cancelText="Don't call"
        confirmText="Call now"
        isLoading={busy}
        onClose={() => resolve("skip")}
        onConfirm={() => resolve("call")}
      />
    </>
  );
};

export default PounceToggle;
